module.exports = __webpack_public_path__ + "img/3.b4be1d45.png";